import { motion } from "framer-motion";
import React from "react";
import { Stack } from "@/core/components/ui/stack";
import { Typography } from "@/core/components/ui/typography";

const ellipsisVariants = {
  animate: {
    opacity: [0.2, 1, 0.2],
    transition: {
      repeat: Infinity,
      duration: 1.2,
      staggerChildren: 0.2,
    },
  },
};

const dotVariants = {
  animate: (i: number) => ({
    opacity: [0.2, 1, 0.2],
    transition: {
      repeat: Infinity,
      duration: 1.2,
      delay: i * 0.2,
    },
  }),
};

interface WaitingPageLayoutProps {
  headline: React.ReactNode;
  body: React.ReactNode;
  children?: React.ReactNode;
}

const WaitingPageLayout: React.FC<WaitingPageLayoutProps> = ({
  headline,
  body,
  children,
}) => (
  <Stack
    fullWidth
    align="center"
    justify="center"
    gap="lg"
    className="h-[calc(100vh-100px)]"
  >
    <Typography variant="headlineW3" className="text-center">
      {headline}
    </Typography>
    <Typography
      variant="bodyW1"
      className="max-w-md text-center text-secondary-text"
    >
      {body}
    </Typography>
    {children}
    <motion.span
      className="flex text-4xl font-bold text-primary-text"
      variants={ellipsisVariants}
      animate="animate"
    >
      {Array.from({ length: 3 }).map((_, i) => (
        <motion.span
          key={i}
          className="mx-1"
          custom={i}
          variants={dotVariants}
          animate="animate"
        >
          .
        </motion.span>
      ))}
    </motion.span>
  </Stack>
);

export default WaitingPageLayout;
